<template>
    <div class="list_bottom_content">
        <div class="row">
            <div class="col-sm-9 info_box">
                <Student v-for="(student, index) in students" v-bind:key="index" :student="student" />
            </div>
            <div class="col-sm-3 patch_box">
                <div class="row">
                    <div v-if="orderDetail.ShowEditButton" class="col-6 col-sm-12">
                        <a href="javascript:void(0);" class="patch hoverShallow" @click.prevent="edit">修改學員資料</a>
                    </div>
                    <div v-if="orderDetail.ShowCancelButton" class="col-6 col-sm-12">
                        <a v-if="orderDetail.CancelOrderFlag" href="javascript:void(0);" class="del hoverFill" @click.prevent="cancel">{{ orderDetail.CancelOrderText }}</a>
                        <a v-else href="javascript:void(0);" class="del btnDark">{{ orderDetail.CancelOrderText }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Student from '@/components/cargo/Student'
    import { mapMutations } from 'vuex'

    export default {
        props: {
            orderDetail: {
                type: Object,
                required: true
            }
        },
        computed: {
            students() {
                return this.orderDetail.student;
            },
        },
        components: {
            Student
        },
        methods: {
            ...mapMutations('orderDetail', [
                'setOrderDetail',
                'setShowModal',
                'setShowCancelModal',
            ]),
            edit() {
                this.setOrderDetail(this.orderDetail);
                this.setShowModal(true);
            },
            cancel() {
                this.setOrderDetail(this.orderDetail);
                this.setShowCancelModal(true);
            },
        },
    }
</script>